import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Form
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { func } from "prop-types";
import Switch from '@material-ui/core/Switch';

function ListadoInventariosCostos() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}`;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [lineas, setLineas] = useState([]);
  const [selectedLineaFiltro, setSelectedLineaFiltro] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");
  const [familias, setFamilias] = useState([]);
  const [selectedFamiliaFiltro, setSelectedFamiliaFiltro] = useState("");
  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const [mayorQue, setMayorQue] = useState(0);
  const [menorQue, setMenorQue] = useState(10000000);
  
  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");

  const [text, setText] = useState(false);
  const [idArticulo, setIdArticulo] = useState("");
  const [SKU, setSKU] = useState("");
  const [costoMX, setCostoMX] = useState("");
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const [idEditArticulo, setIdEditArticulo] = useState("");
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;
  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);

  const [totalTotal, setTotalTotal] = useState(0);
  const [totalTotalDinero, setTotalTotalDinero] = useState(0);
  const [totalTotalVenta, setTotalTotalVenta] = useState(0);
  const [totalTotalBruto, setTotalTotalBruto] = useState(0);
  const [totalTotalNeto, setTotalTotalNeto] = useState(0);
  const [totalTotalCajas, setTotalTotalCajas] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [comments2, setComments2] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  useEffect(() => {
    axios
      .get(`${URL_INVENTARIOS}/AcumuladoCostos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInventarios = response.data;
        // Array para pagination
        let arrayTabla = allInventarios
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            // if(a.cantidad >0){
            return {
              _id: a._id,
              idArticulo: a.idArticulo,
              activo: a.activo,
              cantidad: a.cantidad,
              codigo: a.codigo,
              SKU: a.SKU,
              ASIN: a.ASIN,
              nombre: a.nombre,
              idArticulo: a.idArticulo,
              costoUSD: a.costoUSD,
              costoMX: a.costoMX,
              totalDinero: a.totalDinero,
              venta: a.venta,
              totalVenta: a.totalVenta,
              observaciones: a.observaciones,
              idCompras: a.idCompras,
              piezasPorCaja: a.piezasPorCaja,
              lote: a.lote,
              linea: a.linea,
              idLinea: a.idLinea,
              marca: a.marca,
              idMarca: a.idMarca,
              familia: a.familia,
              idFamilia: a.idFamilia,
              unidadNegocio: a.unidadNegocio,
              idUnidadNegocio: a.idUnidadNegocio,
              proveedor: a.proveedor,
              idProveedor: a.idProveedor,
              cajas: (a.cantidad / a.piezasPorCaja).toFixed(2),
              area: a.area,
              idArea: a.idArea,
              modelo: a.modelo,
              ingresoPromedioBruto: a.ingresoPromedioBruto,
              ingresoPromedioNeto: a.ingresoPromedioNeto,
              totalBruto: (a.cantidad * a.ingresoPromedioBruto).toFixed(2),
              totalNeto: (a.cantidad * a.ingresoPromedioNeto).toFixed(2),
            }

        // }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);

        let unicosMar = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idMarca === value.idMarca)
        );
        setMarcas(unicosMar);
  
        let unicosUni = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idUnidadNegocio === value.idUnidadNegocio)
        );
        setUnidadesNegocio(unicosUni);
  
        let unicosFam = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idFamilia === value.idFamilia)
        );
        setFamilias(unicosFam);
  
        let unicosLinea = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idLinea === value.idLinea)
        );
        setLineas(unicosLinea);
      
      })
      .catch((err) => {
        console.log(err);
      });


    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  function PDFTabla() {
    let total_general = 0;
    let total_cajas = 0;
    // let agrupado = comments2.reduce(function (groups, item) {
    //   const val = item["idArticulo"] + item["idArea"];
    //   groups[val] = groups[val] || {
    //     idArticulo: item.idArticulo,
    //     cantidad: 0,
    //   };
    //   groups[val].cantidad += item.cantidad;
    //   groups[val]._id = item._id;
    //   groups[val].activo = item.activo;
    //   groups[val].nombre = item.nombre;
    //   groups[val].codigo = item.codigo;
    //   groups[val].SKU = item.SKU;
    //   groups[val].idArticulo = item.idArticulo;
    //   groups[val].costoUSD = item.costoUSD;
    //   groups[val].costoMX = item.costoMX;
    //   groups[val].venta = item.venta;
    //   groups[val].observaciones = item.observaciones;
    //   groups[val].idCompras = item.idCompras;
    //   groups[val].piezasPorCaja = item.piezasPorCaja;
    //   groups[val].lote = item.lote;
    //   groups[val].linea = item.linea;
    //   groups[val].idLinea = item.idLinea;
    //   groups[val].marca = item.marca;
    //   groups[val].idMarca = item.idMarca;
    //   groups[val].familia = item.familia;
    //   groups[val].idFamilia = item.idFamilia;
    //   groups[val].unidadNegocio = item.unidadNegocio;
    //   groups[val].idUnidadNegocio = item.idUnidadNegocio;
    //   groups[val].proveedor = item.proveedor;
    //   groups[val].idProveedor = item.idProveedor;
    //   groups[val].area = item.area;
    //   groups[val].idArea = item.idArea;
    //   groups[val].cajas = item.cajas;
    //   return groups;
    // },[])

    // let computedComments = Object.values(agrupado);

    const data = comments2
    .filter((comment) => {
      const q = (search || "").toLowerCase();
      const matches = (v) => String(v ?? "").toLowerCase().includes(q);
      return (
        matches(comment.SKU) ||
        matches(comment.nombre) ||
        matches(comment.linea) ||
        matches(comment.marca) ||
        matches(comment.unidadNegocio) ||
        matches(comment.area) ||
        matches(comment.cajas) ||
        matches(comment.cantidad) ||
        matches(comment.costoMX) ||
        matches(comment.piezasPorCaja)
      );
    })
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        // if (
        //   (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
        //   (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
        //   (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        //   (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
        //   (selectedUnidadNegocio == 0 || selectedUnidadNegocio == a.idUnidadNegocio) &&
        //   (selectedArea == 0 || selectedArea == a.idArea) &&
        //   (activo == 0 || activo == a.is_active)
        // ) {
          total_general = parseFloat(total_general) + parseFloat(a.cantidad)
          total_cajas = parseFloat(total_cajas) + parseFloat(a.cajas)
          return [
            a.SKU,
            a.nombre,
            a.linea,
            a.marca,
            // a.familia,
            a.unidadNegocio,
            a.piezasPorCaja,
            new Intl.NumberFormat("en-US").format(a.cajas),
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US").format(a.costoMX),
            a.area
          ];
        // }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 45, 15);
    doc.text(`Listado Inventarios Costos`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Linea",
          "Marca",
          // "Familia",
          "UnidadNegocio",
          "PxC",
          "Cajas",
          "Cantidad",
          "Costo Unitario",
          "Almacen",

        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
        [
          "",
          "",
          // "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(total_cajas),
          new Intl.NumberFormat("en-US").format(total_general),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`InventariosCostos.pdf`);
  }

  function excel() {
    let total_general = 0;
    let total_cajas = 0;
    // let agrupado = comments2.reduce(function (groups, item) {
    //   const val = item["idArticulo"] + item["idArea"];
    //   groups[val] = groups[val] || {
    //     idArticulo: item.idArticulo,
    //     cantidad: 0,
    //   };
    //   groups[val].cantidad += item.cantidad;
    //   groups[val]._id = item._id;
    //   groups[val].activo = item.activo;
    //   groups[val].nombre = item.nombre;
    //   groups[val].codigo = item.codigo;
    //   groups[val].SKU = item.SKU;
    //   groups[val].idArticulo = item.idArticulo;
    //   groups[val].costoUSD = item.costoUSD;
    //   groups[val].costoMX = item.costoMX;
    //   groups[val].venta = item.venta;
    //   groups[val].observaciones = item.observaciones;
    //   groups[val].idCompras = item.idCompras;
    //   groups[val].piezasPorCaja = item.piezasPorCaja;
    //   groups[val].lote = item.lote;
    //   groups[val].linea = item.linea;
    //   groups[val].idLinea = item.idLinea;
    //   groups[val].marca = item.marca;
    //   groups[val].idMarca = item.idMarca;
    //   groups[val].familia = item.familia;
    //   groups[val].idFamilia = item.idFamilia;
    //   groups[val].unidadNegocio = item.unidadNegocio;
    //   groups[val].idUnidadNegocio = item.idUnidadNegocio;
    //   groups[val].proveedor = item.proveedor;
    //   groups[val].idProveedor = item.idProveedor;
    //   groups[val].area = item.area;
    //   groups[val].idArea = item.idArea;
    //   groups[val].cajas = item.cajas;
    //   return groups;
    // },[])

    // let computedComments = Object.values(agrupado);

    const data = comments2
    .filter((comment) => {
      const q = (search || "").toLowerCase();
      const matches = (v) => String(v ?? "").toLowerCase().includes(q);
      return (
        matches(comment.SKU) ||
        matches(comment.nombre) ||
        matches(comment.linea) ||
        matches(comment.marca) ||
        matches(comment.unidadNegocio) ||
        matches(comment.area) ||
        matches(comment.cajas) ||
        matches(comment.cantidad) ||
        matches(comment.costoMX) ||
        matches(comment.piezasPorCaja)
      );
    })
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        // if (
        //   (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
        //   (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
        //   (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        //   (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
        //   (selectedUnidadNegocio == 0 || selectedUnidadNegocio == a.idUnidadNegocio) &&
        //   (selectedArea == 0 || selectedArea == a.idArea) &&
        //   (activo == 0 || activo == a.is_active)
        // ) {
          total_general = parseFloat(total_general) + parseFloat(a.cantidad)
          total_cajas = parseFloat(total_cajas) + parseFloat(a.cajas)
        return {
          SKU: a.SKU,
          ASIN: a.ASIN,
          Nombre: a.nombre,
          Linea: a.linea,
          Marca: a.marca,
          // Familia: a.familia,
          UnidadNegocio: a.unidadNegocio,
          PiezasPorCaja: a.piezasPorCaja,
          Cajas: a.cajas,
          Cantidad: a.cantidad,
          CostoMX: a.costoMX,
          Almacen: a.area,
          // IdInv: a._id,
          // IdArticulo: a.idArticulo
        };
      // }
    });
    const dataExportExcel = Object.values(data);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoInventariosCostos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoInventariosCostos",
        sheetFilter: [
          "SKU",
          "ASIN",
          "Nombre",
          "Linea",
          "Marca",
          // "Familia",
          "UnidadNegocio",
          "PiezasPorCaja",
          "Cajas",
          "Cantidad",
          "CostoMX",
          "Almacen",
          // "IdInv",
          // "IdArticulo",
        ],
        sheetHeader: [
          "SKU",
          "ASIN",
          "Nombre",
          "Linea",
          "Marca",
          // "Familia",
          "UnidadNegocio",
          "PiezasPorCaja",
          "Cajas",
          "Cantidad",
          "CostoMX",
          "Almacen",
          // "IdInv",
          // "IdArticulo",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let total_general = 0;
    let total_cajas = 0;
    // let agrupado = comments2.reduce(function (groups, item) {
    //   const val = item["idArticulo"] + item["idArea"];
    //   groups[val] = groups[val] || {
    //     idArticulo: item.idArticulo,
    //     cantidad: 0,
    //   };
    //   groups[val].cantidad += item.cantidad;
    //   groups[val]._id = item._id;
    //   groups[val].activo = item.activo;
    //   groups[val].nombre = item.nombre;
    //   groups[val].codigo = item.codigo;
    //   groups[val].idArticulo = item.idArticulo;
    //   groups[val].costoUSD = item.costoUSD;
    //   groups[val].costoMX = item.costoMX;
    //   groups[val].venta = item.venta;
    //   groups[val].observaciones = item.observaciones;
    //   groups[val].idCompras = item.idCompras;
    //   groups[val].piezasPorCaja = item.piezasPorCaja;
    //   groups[val].lote = item.lote;
    //   groups[val].linea = item.linea;
    //   groups[val].idLinea = item.idLinea;
    //   groups[val].marca = item.marca;
    //   groups[val].idMarca = item.idMarca;
    //   groups[val].familia = item.familia;
    //   groups[val].idFamilia = item.idFamilia;
    //   groups[val].unidadNegocio = item.unidadNegocio;
    //   groups[val].idUnidadNegocio = item.idUnidadNegocio;
    //   groups[val].proveedor = item.proveedor;
    //   groups[val].idProveedor = item.idProveedor;
    //   groups[val].area = item.area;
    //   groups[val].idArea = item.idArea;
    //   groups[val].cajas = item.cajas;
    //   return groups;
    // },[])

    // let computedComments = Object.values(agrupado);

    const data = comments2
    .filter((comment) => {
      const q = (search || "").toLowerCase();
      const matches = (v) => String(v ?? "").toLowerCase().includes(q);
      return (
        matches(comment.codigo) ||
        matches(comment.nombre) ||
        matches(comment.linea) ||
        matches(comment.marca) ||
        matches(comment.unidadNegocio) ||
        matches(comment.area) ||
        matches(comment.cajas) ||
        matches(comment.cantidad) ||
        matches(comment.costoMX) ||
        matches(comment.piezasPorCaja)
      );
    })
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        // if (
        //   (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
        //   (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
        //   (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        //   (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
        //   (selectedUnidadNegocio == 0 || selectedUnidadNegocio == a.idUnidadNegocio) &&
        //   (selectedArea == 0 || selectedArea == a.idArea) &&
        //   (activo == 0 || activo == a.is_active)
        // ) {
          total_general = parseFloat(total_general) + parseFloat(a.cantidad)
          total_cajas = parseFloat(total_cajas) + parseFloat(a.cajas)
          return [
            a.codigo,
            a.nombre,
            a.linea,
            a.marca,
            // a.familia,
            a.unidadNegocio,
            a.piezasPorCaja,
            new Intl.NumberFormat("en-US").format(a.cajas),
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US").format(a.costoMX),
            a.area
          ];
        // }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 45, 15);
    doc.text(`Listado Inventarios Costos`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Linea",
          "Marca",
          // "Familia",
          "UnidadNegocio",
          "PxC",
          "Cajas",
          "Cantidad",
          "Costo Unitario",
          "Almacen",

        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
        [
          "",
          // "",
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(total_cajas),
          new Intl.NumberFormat("en-US").format(total_general),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Inventarios Costos",
          email: mailTo,
          fileName: "ListadoInventariosCostos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Inventarios Costos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

 

  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    // { name: "ASIN", field: "ASIN", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    // { name: "Linea", field: "linea", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    { name: "Unidad Negocio", field: "unidadNegocio", sortable: true },
    // { name: "Pzas. Caja", field: "piezasPorCaja", sortable: true },
    // { name: "Cajas", field: "cajas", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Costo Unitario", field: "costoMX", sortable: true },
    { name: "Total Costo Unitario", field: "totalDinero", sortable: true },
    { name: "Ingreso Prom Bruto", field: "ingresoPromedioBruto", sortable: true },
    { name: "Total Bruto", field: "totalBruto", sortable: true },
    { name: "Ingreso Prom Neto", field: "ingresoPromedioNeto", sortable: true },
    { name: "Total Neto", field: "totalNeto", sortable: true },
    { name: "Venta Minima Unitaria", field: "venta", sortable: true },
    { name: "Total Venta Minima", field: "totalVenta", sortable: true },
    // { name: "Almacen", field: "area", sortable: true },
    // { name: "Foto", field: "foto", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      const q = search.toLowerCase();
      const matches = (v) => String(v ?? "").toLowerCase().includes(q);
      computedComments = computedComments.filter(
        (comment) =>
          matches(comment.SKU) ||
          matches(comment.nombre) ||
          matches(comment.marca) ||
          matches(comment.unidadNegocio) ||
          matches(comment.area) ||
          matches(comment.cantidad) ||
          matches(comment.costoMX) ||
          matches(comment.totalDinero) ||
          matches(comment.totalBruto) ||
          matches(comment.totalNeto) ||
          matches(comment.ingresoPromedioBruto) ||
          matches(comment.ingresoPromedioNeto) ||
          matches(comment.venta) ||
          matches(comment.totalVenta) ||
          matches(comment.piezasPorCaja)
      );
    }

    // if (selectedLineaFiltro) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idLinea.includes(selectedLineaFiltro)
    //   );
    // }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }
    // if (selectedMarca) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idMarca.includes(selectedMarca)
    //   );
    // }
    if (selectedArticulo) {
      computedComments = computedComments.filter((e) =>
        e.idArticulo.includes(selectedArticulo)
      );
    }
    // if (selectedFamiliaFiltro) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idFamilia.includes(selectedFamiliaFiltro)
    //   );
    // }
    // if (selectedUnidadNegocio) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idUnidadNegocio.includes(selectedUnidadNegocio)
    //   );
    // }
    if (selectedArea) {
      computedComments = computedComments.filter((e) =>
        e.idArea.includes(selectedArea)
      );
    }


    if (mayorQue) {
      computedComments = computedComments.filter(
        (e) => e.cantidad >= mayorQue
      );
    }

    if (menorQue) {
      computedComments = computedComments.filter(
        (e) => e.cantidad <= menorQue
      );
    }


    if(selectedUnidadNegocio.length > 0){
      if (selectedUnidadNegocio) {
        computedComments = computedComments.filter((e) =>
          selectedUnidadNegocio.some((a) => e.idUnidadNegocio && e.idUnidadNegocio.includes(a))
        );
      }
    }
    
    
    if(selectedMarca.length > 0){
      if (selectedMarca) {
        computedComments = computedComments.filter((e) =>
          selectedMarca.some((a) => e.idMarca && e.idMarca.includes(a))
        );
      }
    }
    
    
    if(selectedLineaFiltro.length > 0){
      if (selectedLineaFiltro) {
        computedComments = computedComments.filter((e) =>
          selectedLineaFiltro.some((a) => e.idLinea && e.idLinea.includes(a))
        );
      }
    }

    let can = computedComments.map((c) => parseFloat(c.cantidad));
    let TCan = can.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotal(TCan);

    let din = computedComments.map((c) => parseFloat(c.totalDinero));
    let TDin = din.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalDinero(TDin);

        let ven = computedComments.map((c) => parseFloat(c.totalVenta));
    let TVen = ven.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalVenta(TVen);

            let venBruto = computedComments.map((c) => parseFloat(c.totalBruto));
    let TVenBruto = venBruto.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalBruto(TVenBruto);

            let venNeto = computedComments.map((c) => parseFloat(c.totalNeto));
    let TVenNeto = venNeto.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalNeto(TVenNeto);

    let caj = computedComments.map((c) => parseFloat(c.cajas));
    let Tcaj = caj.reduce((t, cajas, index) => t + cajas, 0);
    setTotalTotalCajas(Tcaj);

    setTotalItems(computedComments.length);

    setComments2(computedComments)

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "costoMX" &&
      sorting.field != "totalDinero" &&
      sorting.field != "totalVenta" &&
      sorting.field != "piezasPorCaja" &&
      sorting.field != "cajas" &&
      sorting.field != "ingresoPromedioBruto" &&
      sorting.field != "ingresoPromedioNeto" &&
      sorting.field != "totalBruto" &&
      sorting.field != "totalNeto" &&
      sorting.field != "venta"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "costoMX" ||
        sorting.field == "totalDinero" ||
        sorting.field == "totalVenta" ||
        sorting.field == "piezasPorCaja" ||
        sorting.field == "cajas" ||
        sorting.field == "ingresoPromedioBruto" ||
        sorting.field == "ingresoPromedioNeto" ||
        sorting.field == "totalBruto" ||
        sorting.field == "totalNeto" ||
        sorting.field == "venta")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "costoMX" ||
        sorting.field == "totalDinero" ||
        sorting.field == "totalVenta" ||
        sorting.field == "piezasPorCaja" ||
        sorting.field == "cajas" ||
        sorting.field == "ingresoPromedioBruto" ||
        sorting.field == "ingresoPromedioNeto" ||
        sorting.field == "totalBruto" ||
        sorting.field == "totalNeto" ||
        sorting.field == "venta")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedArticulo,
    activo,
    selectedLineaFiltro,
    selectedMarca, 
    // selectedFamiliaFiltro, 
    selectedUnidadNegocio,
    selectedArea,
    mayorQue,
    menorQue
  ]);


  function limpiarSearch(){
    setSearch("")
    setSelectedArticulo("")
    setSelectedLineaFiltro("")
    setSelectedMarca("")
    setSelectedFamiliaFiltro("")
    setSelectedUnidadNegocio("")
    setSelectedArea("")
  }

  
  function jalaFoto(
    idEdit
  ) {
    setPhoto("")
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));


    setIdEditArticulo(idEdit);
    toggleFoto();
  }

  const handleCheckboxChangeUnidadNegocio = (e) => {
    const { value, checked } = e.target;
    // Actualiza el estado de los artículos seleccionados
    if (checked) {
      setSelectedUnidadNegocio([...selectedUnidadNegocio, value]);
    } else {
      setSelectedUnidadNegocio(selectedUnidadNegocio.filter(item => item !== value));
    }
  };

  const handleCheckboxChangeMarca = (e) => {
    const { value, checked } = e.target;
    // Actualiza el estado de los artículos seleccionados
    if (checked) {
      setSelectedMarca([...selectedMarca, value]);
    } else {
      setSelectedMarca(selectedMarca.filter(item => item !== value));
    }
  };

  const handleCheckboxChangeLinea = (e) => {
    const { value, checked } = e.target;
    // Actualiza el estado de los artículos seleccionados
    if (checked) {
      setSelectedLineaFiltro([...selectedLineaFiltro, value]);
    } else {
      setSelectedLineaFiltro(selectedLineaFiltro.filter(item => item !== value));
    }
  };

  function EditCostoMX(
    idArticulo,
    SKU,
    costoMX
  ) {
    setIdArticulo(idArticulo)
    setSKU(SKU)
    setCostoMX(costoMX)
    toggleEdit();
  }

  const EditCostoMXSave = (event) => {
    event.preventDefault();
    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el Costo MX",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ARTICULOS}EditarCostoMX/${idArticulo}`,
            {
              costoMX
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Costo Articulo",
                detalle: `${SKU}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  };

  let total = 0;
  let total_cajas = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.inventarios_costosAdmin ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
              
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Inventarios Costos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
         
          <h3 align="center">Inventarios Costos</h3>
          <div className="row">
            <div className="col-md-2">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div> 
            
            <div className="col-md-2">
            <ul>
            <Label className="negrita" align="center">UNIDAD NEGOCIO</Label>
  {unidadesNegocio.map((a) => (
    <li key={a.idUnidadNegocio}>
      <label>
        <Switch
          value={a.idUnidadNegocio}
          checked={selectedUnidadNegocio.includes(a.idUnidadNegocio)}
          onChange={(e) => handleCheckboxChangeUnidadNegocio(e, a.idUnidadNegocio)}
          color="primary"
/>
        {a.unidadNegocio}
      </label>
    </li>
  ))}
</ul>
            </div>


            <div className="col-md-2">
            <ul>
            <Label className="negrita" align="center">MARCA</Label>
  {marcas.map((a) => (
    <li key={a.idMarca}>
      <label>
        <Switch
           value={a.idMarca}
           checked={selectedMarca.includes(a.idMarca)}
           onChange={(e) => handleCheckboxChangeMarca(e, a.idMarca)}
           color="primary"
/>
        {a.marca}
      </label>
    </li>
  ))}
</ul>
            </div>

            {/* <div className="col-md-2">
            <ul>
            <Label className="negrita" align="center">LINEA</Label>
  {lineas.map((a) => (
    <li key={a.idLinea}>
      <label>
        <Switch
          value={a.idLinea}
          checked={selectedLineaFiltro.includes(a.idLinea)}
          onChange={(e) => handleCheckboxChangeLinea(e, a.idLinea)}
          color="primary"
        />
        {a.linea}
      </label>
    </li>
  ))}
</ul>
            </div> */}
            
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
             <div className="col-md-1 flex-row-reverse">
            <Button
                  size="sm"
                  className="btn"
                  color="info"
                  onClick={limpiarSearch}
                >
                  Limpiar
                </Button>
                </div>
           
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Mayor Que</Label>
              <Input
                bsSize="sm"
                type="number"
                value={mayorQue}
                required
                onChange={(e) => {
                  setMayorQue(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Menor Que</Label>
              <Input
                bsSize="sm"
                type="number"
                value={menorQue}
                required
                onChange={(e) => {
                  setMenorQue(e.target.value);
                }}
              />
            </Col>

          
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulos
                    .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.SKU}</option>;
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulos
                    .sort((a, b) => (a.ASIN > b.ASIN ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.ASIN}</option>;
                    })}
                </Input>
              </td> */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulos
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.nombre}</option>;
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLineaFiltro}
                  onChange={(e) => {
                    setSelectedLineaFiltro(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a > b ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td> */}

              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedFamiliaFiltro}
                  onChange={(e) => {
                    setSelectedFamiliaFiltro(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>*/}
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedUnidadNegocio}
                  onChange={(e) => {
                    setSelectedUnidadNegocio(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {unidadesNegocio
                    .sort((a, b) => (a > b ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td> 
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArea}
                  onChange={(e) => {
                    setSelectedArea(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                        })}
                </Input>
              </td>
              <td></td> */}
            </tr>
            <tbody>
              {commentsData.map((a) => {
                total = total + parseFloat(a.cantidad);
                total_cajas = total_cajas + parseFloat(a.cajas);
                {
                  return (
                    <tr>
                      <td>{a.SKU}</td>
                      {/* <td>{a.ASIN}</td> */}
                      <td>{a.nombre}</td>
                      {/* <td>{a.linea}</td> */}
                      <td>{a.marca}</td>
                      <td>{a.unidadNegocio}</td> 
                      {/* <td>{a.piezasPorCaja}</td> */}
                      {/* <td>
                        { new Intl.NumberFormat("en-US").format(a.cajas)}
                      </td> */}
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.cantidad)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalDinero)}
                      </td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.ingresoPromedioBruto)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalBruto)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.ingresoPromedioNeto)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalNeto)}</td>
                       <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.venta)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalVenta)}
                      </td>
                      {/* <td>{a.area}</td> */}
                      {/* <td>
                      <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaFoto(
                                  a.idArticulo
                                )
                              }
                            >
                              <i class="fas fa-camera"></i>
                            </Button> 
                            <Button
                              size="sm"
                              className="btn"
                              color="info"
                                onClick={(e) =>
                                  EditCostoMX(
                                    a.idArticulo,
                                    a.SKU,
                                    a.costoMX
                                  )
                                }
                              >
                                <i class="fas fa-edit"></i>
                              </Button>
                      </td> */}
                    </tr>
                  );
                }
              })}
              {/* <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td> 
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(total_cajas)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(total)}
                </td>
                <td></td>
                <td></td>
              </tr> */}
              <tr>
                {/* <td></td>
                <td></td>
                <td></td> */}
                <td></td> 
                <td></td>
                <td></td>
                <td className="negrita">TOTAL GENERAL</td>
                {/* <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalTotalCajas)}
                </td> */}
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalTotal)}
                </td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDinero)}
                </td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalBruto)}
                </td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalNeto)}
                </td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalVenta)}
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
  <Modal size="sm" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>
            Foto
          </h4>
        </ModalHeader>
        <ModalBody>
        <Row>
            {photo ? (
              <h6 style={{ textAlign: "center" }}>
                <img
                  // loading="lazy"
                  src={`${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/v${photo}/arcoshopArticulos/${idEditArticulo}.jpg`}
                  alt=""
                />
              </h6>
            ) : <h4>No se ha subido una Foto....</h4>}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalEdit} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>
              <h4>Editar Costo del Articulo {SKU}</h4>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={EditCostoMXSave}>
                {/* <Row>
                  <Col md={6}>
                    <Label>Fecha</Label>
                    <Input
                      type="date"
                      value={fechaEdit}
                      required
                      disabled
                    />
                  </Col>
                </Row> */}
                <Row>
                  <Col md={12}>
                    <Label>Costo MX</Label>
                    <Input
                      className="col-sm-12"
                      type="number"
                      placeholder="CostoMX"
                      value={costoMX}
                      required
                      onChange={(e) => {
                        setCostoMX(e.target.value);
                      }}
                    />
                  </Col>
                </Row>

                <br />
                <Row>
                    <Button type="submit" className="btn btn-success">
                      Guardar
                    </Button>

                  <div>
                    <SweetAlert
                      show={text}
                      title="Guardado con Exito"
                      onConfirm={() => {
                        setText(false);
                      }}
                    />
                  </div>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
     
      {loader}
    </>
  );
}

export default ListadoInventariosCostos;
